<div mat-dialog-content>
  <h2>EAN / GTIN</h2>
  <p class="gtin-top-text">Hva er det og hvor finner du det</p>

  <div class="gtin-image-container">
    <img alt="How to find GTIN" class="image" [src]="imageAssets.gtin" />
  </div>

  <p class="gtin-info-text">
    EAN (European Article Number) er en standardisert tallkode som gir en unik identifikasjon av et produkt. Fra EAN-koden
    <span class="highlight-text">0194252716885</span>
    kan man eksempelvis utlede
    <span class="highlight-text">Apple iPhone 13 Pro 5G 256GB - Silver.</span>
    Kjært barn har som kjent mange navn, og du kan også støte på begrep som
    <span class="highlight-text">GTIN</span>
    eller
    <span class="highlight-text">UPC</span>
    , men for alle praktiske formål betyr det akkurat det samme.
  </p>
  <p class="gtin-header-text">Hvorfor trenger vi EAN/GTIN:</p>
  <ul class="gtin-info-text">
    <li>For å unngå svindelsaker.</li>
    <li>For å kunne identifisere telefonens merke, modell og spesifikasjoner.</li>
    <li>For å kunne tilby riktig pris på blant annet mobilforsikring.</li>
  </ul>

  <p class="gtin-header-text">Hvor finner du EAN/GTIN:</p>
  <p class="gtin-info-text">
    EAN-koden finner man som regel på baksiden av forpakningen på høyre side, eller på den korte undersiden, se bildet over.
  </p>
</div>

<div mat-dialog-actions>
  <div class="buttons">
    <app-ice-button
      color="outlined"
      tabindex="0"
      testId="close-gtin-info-dialog-button"
      (click)="dialogRef.close()"
      (keydown.enter)="dialogRef.close()"
    >
      Ok, lukk
    </app-ice-button>
  </div>
</div>
